import { render, staticRenderFns } from "./ShowUser.vue?vue&type=template&id=00c98256"
import script from "./ShowUser.vue?vue&type=script&lang=js"
export * from "./ShowUser.vue?vue&type=script&lang=js"
import style0 from "./ShowUser.vue?vue&type=style&index=0&id=00c98256&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports